import { useEffect, useState } from "react";
import type { LLMModel } from "../api/llm";
import { ModelSelect } from "./model-select";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";

interface CreateChatRoomModalProps {
  isOpen: boolean;
  onClose: () => void;
  characterId: string;
  onCreateChatRoom: (chatRoomName: string, characterId: string, model: LLMModel) => Promise<void>;
  models: LLMModel[];
}

export function CreateChatRoomModal({
  isOpen,
  onClose,
  characterId,
  onCreateChatRoom,
  models,
}: CreateChatRoomModalProps) {
  const [chatRoomName, setChatRoomName] = useState("");
  const [selectedModel, setSelectedModel] = useState<LLMModel | null>(null);

  useEffect(() => {
    if (models.length > 0 && !selectedModel) {
      setSelectedModel(models[0]);
    }
  }, [models, selectedModel]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (chatRoomName.trim() && selectedModel) {
      await onCreateChatRoom(chatRoomName.trim(), characterId, selectedModel);
      setChatRoomName("");
      setSelectedModel(models[0]);
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>データ管理タグを作成</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div>
              <label htmlFor="chatRoomName" className="block text-sm font-medium text-gray-700 mb-1">
                データ管理タグ名
              </label>
              <Input
                id="chatRoomName"
                placeholder="データ管理タグ名を入力"
                value={chatRoomName}
                onChange={(e) => setChatRoomName(e.target.value)}
                autoFocus
              />
            </div>
            <div>
              <label htmlFor="modelSelect" className="block text-sm font-medium text-gray-700 mb-1">
                モデル
              </label>
              {selectedModel && <ModelSelect value={selectedModel} onChange={setSelectedModel} models={models} />}
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              キャンセル
            </Button>
            <Button type="submit" disabled={!chatRoomName.trim() || !characterId.trim() || !selectedModel}>
              作成
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
